import { FormikErrors } from "formik";


export const checkTabHasErrors = (
  fieldList: string[],
  errors: FormikErrors<any>,
  touched: any
): boolean => {
  
  if (!fieldList || fieldList.length === 0) {
    return false;
  }

  return fieldList.some((fieldPath) => {
    if (fieldPath === "apartments") {
      return checkArrayFieldErrors(errors.apartments, touched.apartments);
    }

    if (fieldPath === "parkings") {
      return checkArrayFieldErrors(errors.parkings, touched.parkings);
    }

    return checkFieldError(fieldPath, errors, touched);
  });
};

const checkArrayFieldErrors = (
  arrayErrors: any,
  arrayTouched: any
): boolean => {
  if (!arrayErrors || !arrayTouched) {
    return false;
  }

  if (typeof arrayErrors === "string") {
    return !!arrayTouched;
  }

  if (!Array.isArray(arrayErrors) || !Array.isArray(arrayTouched)) {
    return false;
  }

  return arrayErrors.some((itemErrors, index) => {
    const itemTouched = arrayTouched[index];

    if (!itemErrors || !itemTouched) {
      return false;
    }

    if (typeof itemErrors === "string") {
      return true;
    }

    return Object.keys(itemErrors).some((fieldName) => {
      return itemTouched[fieldName] && !!itemErrors[fieldName];
    });
  });
};

const checkFieldError = (
  fieldPath: string,
  errors: any,
  touched: any
): boolean => {
  const pathParts = fieldPath.split(/[\.\[\]]+/).filter(Boolean);

  let currentError = errors;
  let currentTouched = touched;

  for (const part of pathParts) {
    if (currentError === undefined || currentTouched === undefined) {
      return false;
    }

    currentError = currentError[part];
    currentTouched = currentTouched[part];
  }

  return !!currentTouched && !!currentError;
};
